import { Grid, Paper, TableFooter, TablePagination } from "@material-ui/core";
import {
  createStyles, makeStyles,
  Theme
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import { Edit } from "@material-ui/icons";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import Button from '@mui/material/Button';
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { StyledTableCell, StyledTableRow } from "../../containers/StyledTableCell";
import { getSequencing } from "../../store/actions";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    table: {
      minWidth: 700,
    },
    hoveItem: {
      cursor: "pointer",
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    card: {
      height: "100%",
      padding: "20px",
    },
    text: { color: "black" },
  })
);

interface Props {
  getSequencing: any;
  fetchRunSequencing: any;
  setRun: any;
  setValue: any;
  setOnboardingActionType: any;

}
const StopsPlace: React.FC<Props> = ({
  getSequencing,
  fetchRunSequencing,
  setRun,
  setValue,
  setOnboardingActionType,

}) => {
  const classes = useStyles();
  const [page, setPage] = useState(0);

  useEffect(() => {
    getSequencing();
  }, [])

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = fetchRunSequencing.links && fetchRunSequencing.links.next.split("?")[1];
      getSequencing(`?${url}`);
    } else if (newPage < page) {
      let url = fetchRunSequencing.links && fetchRunSequencing.links.previous.split("?")[1];
      getSequencing(`${url}`);
    }
    setPage(newPage);
  };
  return (
    <Grid container spacing={2} style={{ marginTop: 20 }}>
      <Grid container style={{ marginTop: 10 }}>
        <TableContainer
          className={classes.tableContainer}
          component={Paper}
          style={{ maxHeight: "480px" }}
        >
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <StyledTableCell align="center">Run ID</StyledTableCell>
              <StyledTableCell align="center">No Of Lane</StyledTableCell>
              <StyledTableCell align="center">No Of Library</StyledTableCell>
              <StyledTableCell align="center">No Of Single Index</StyledTableCell>
              <StyledTableCell align="center">No Of Dual Index</StyledTableCell>
              <StyledTableCell align="center">Download Run Plan</StyledTableCell>
              <StyledTableCell align="center">Edit</StyledTableCell>
              {/* <StyledTableCell align="center">Enter Data Capture</StyledTableCell> */}
            </TableHead>
            {fetchRunSequencing && fetchRunSequencing?.results && fetchRunSequencing?.results?.map((data: any, index: any) =>
              <TableBody>
                <StyledTableRow >
                  <StyledTableCell align="center">
                    {data?.runId}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {data?.laneCount}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {data?.libraries?.length}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {data?.singleIndexCount}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {data?.dualIndexCount}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <StyledTableCell align="center">
                      <a href={`${process.env.REACT_APP_API_PATH}api/beta1/genomics/runs/${data?._id}/runsheet`} download style={{ color: "blueviolet", marginLeft: 60 }}><DownloadForOfflineIcon /></a>
                    </StyledTableCell>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Button
                      color="primary"
                      variant="contained"
                    >
                      <Edit onClick={() => {
                        setRun(data)
                        setValue(1)
                        setOnboardingActionType("Edit Sequence")
                      }} />
                    </Button>
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            )}
            <TableFooter>
              <TablePagination
                rowsPerPageOptions={[]}
                colSpan={3}
                count={fetchRunSequencing?.count || 0}
                rowsPerPage={fetchRunSequencing?.page_size}
                page={page}
                onPageChange={handleChangePage}
              />
            </TableFooter>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
const mapStateToProps = (state: any) => ({
  fetchRunSequencing: state.GenomicsLabReducer.fetchRunSequencing,

});
export default connect(mapStateToProps, {
  getSequencing,

})(StopsPlace);
